import { Button, SxProps, Theme } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';

export const ButtonAdd = ({ onClick, text, sx }: {
    text?: string; onClick?: () => void,
    sx?: SxProps<Theme>;
}) => {
    return (
        <Button
            color="success"
            variant="contained"
            onClick={onClick}
            sx={{
                color: 'black',
                backgroundColor: '#B4E380',
                '&:hover': {
                    backgroundColor: '#88D66C',
                },
                ...sx
            }}
        >
            <AddTwoToneIcon /> {text}
        </Button>
    );
};
